<template>
  <div class="navStyle">
    <div id="nav">
      <div class="navCont">
        <div class="logo">
          <img src="/static/nav/logo.png" />
        </div>
        <div class="navMenu" @click="showMenu">
          <img src="/static/nav/menu.png" alt="">
        </div>
      </div>
    </div>
    <div @click.self="hideMenu" :class="['menuStyle',{showStyle:isMenu}]">
      <el-menu
        :default-active="activeMenu"
        @select="selectMenu"
        menu-trigger="click"
        :class="['el-menu-vertical-demo','verMenu',{showStyle:isMenu}]"
      >
        <template>
          <sidebar-item
            v-for="route in menus[0].children"
            :key="route.path"
            :item="route"
            :base-path="route.path"
          />
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
export default {
  name: 'Navbar',
  components: { SidebarItem },
  data () {
    return {
      isMenu: false,
      num: 0
    }
  },
  props: {},
  computed: {
    ...mapGetters(['menus']),
    activeMenu () {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }
  },
  methods: {
    showMenu () {
      this.isMenu = true
    },
    hideMenu () {
      this.isMenu = false
    },
    selectMenu (index) {
      console.log('selectMenu index', index)
      this.hideMenu()
    }
  }
}
</script>

<style scoped lang="scss">
.navStyle {
  width: 100%;
  position: fixed;
  z-index: 20;

  top: 0;
  left: 0;
  box-shadow:2px 0 2px #ccc;
  #nav {
    width: 100%;
    background: #fff;
    z-index: 10;
    display: flex;
    justify-content: center;
    .navCont {
      width:100%;
      height: 0.96rem;
      background: -webkit-linear-gradient(left,#5749e6,#2fcfda); /* Safari 5.1-6.0 */
      background: -o-linear-gradient(left,#5749e6,#2fcfda); /* Opera 11.1-12.0 */
      background: -moz-linear-gradient(left,#5749e6,#2fcfda); /* Firefox 3.6-15 */
      background: linear-gradient(left,#5749e6,#2fcfda); /* 标准语法 */
      line-height: 0.96rem;
      padding: 0 0.3rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .logo {
        line-height: 0.96rem;
        text-align: left;
        img {
          vertical-align: middle;
          width: 1.2rem;
        }
      }
      .navMenu {
        img{
          width:0.6rem;
          vertical-align: middle;
        }
      }
    }
  }
  .menuStyle {
    position: fixed;
    top: 0;
    right:-7.6rem;
    height: 100%;
    width:100%;
    z-index: 12;
    transition: all 0.5s;
    display:flex;
    justify-content:flex-end;
    .verMenu {
      height: 100%;
      background: rgba($color: #191f2b, $alpha: 0.9);
      z-index: 14;
    }
  }
  .showStyle {
    right: 0 !important;
  }

  /deep/.menu-wrapper {
    display: block;
    margin: 0;
    width: 3.4rem;
    border-bottom: 1px solid #60646d;
  }
  /deep/.el-menu-item {
    a {
      display: inline-block;
      font-size: 0.3rem;
      text-align: center;
      // height:0.6rem;
      // line-height:0.6rem;
      color: #fff;
    }
  }
  /deep/.el-menu-item:focus,
  /deep/.el-menu-item:hover {
    background-color: transparent;
  }
  /deep/.el-menu-item,
  /deep/.el-submenu__title {
    height: 0.9rem;
    line-height: 0.9rem;
  }
  /deep/.el-submenu__title {
    //子菜单样式
    color: #fff;
    font-size: 0.3rem;
  }
  /deep/.el-submenu__title:focus,
  /deep/.el-submenu__title:hover {
    background-color: transparent;
  }
  /deep/.el-submenu {
    .el-menu {
      background: transparent;
      .el-menu-item {
        min-width: auto;
        padding: 0 !important;
      }
    }
  }
  /deep/.el-menu-item.is-active {
    a {
      color: #5352b6;
    }
  }
}
</style>
